import { render, staticRenderFns } from "./TradingApp.vue?vue&type=template&id=1e0ec486&scoped=true"
import script from "./TradingApp.vue?vue&type=script&lang=js"
export * from "./TradingApp.vue?vue&type=script&lang=js"
import style0 from "./TradingApp.vue?vue&type=style&index=0&id=1e0ec486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0ec486",
  null
  
)

export default component.exports